import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Check, View, Waiting } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { Cell } from '../Cell';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';

const Container = styled.div``;

const STATE = {
  approve: false,
};

/* eslint-disable react/prefer-stateless-function */
class BVIBotStep2Comp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  renderApprove() {
    if (!this.state.approve) return null;
    if (!this.vehicle) return '...';
    return (
      <Modal onClose={this.reset.bind(this)} title={this.lbl('kanbanboards.cell.BVIBotStep2.modal.title')}>
        De bot gaat nu de de auto machtigen, tenaamstellen en opnemen in de bedrijfsvoorraad. <br />
        {['BVI_step2_started', 'machtigingsnummer', 'BVI_step2_2.4.1', 'BVI_step2_2.4.2'].map(propName => {
          if (this.vehicle[propName])
            return (
              <div key={propName}>
                <Check />
                {propName}
              </div>
            );
          return (
            <div key={propName}>
              <Waiting />
              {propName}
            </div>
          );
        })}
        <br /> Als dit binnen een uur niet gebeurd is, is er iets mis.
        <ModalControls>
          <Button onClick={this.reset.bind(this)}>{this.lbl('ok')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell>
        <Container>
          <VehicleHeader vehicle={vehicle} />
          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <CellButton onClick={this.setStateFn({ approve: !this.state.approve })}>
                  <View />
                </CellButton>

                {/* <CellButton onClick={() => this.toHelgaVehicle(vehicle.vehicle_helga_id)}>
                  <img height="23" src="/public/helga_icon.svg" />
                </CellButton> */}
              </>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

BVIBotStep2Comp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const BVIBotStep2 = compose(
  withConnect,
  withRouter,
)(BVIBotStep2Comp);
